"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Karen S.",
  quote: "LeavingIL made my home selling process seamless and stress-free. Their expert guidance and personalized approach helped me understand my options clearly.",
  position: "Homeowner, Illinois Resident"
}, {
  author: "Michael R.",
  quote: "I was overwhelmed by the thought of moving to Tennessee, but the Exit Strategy Planning gave me the roadmap I needed to move with confidence.",
  position: "Relocated Resident"
}, {
  author: "Sarah J.",
  quote: "The precise valuation of my Illinois home was eye-opening. They connected me with a top-tier agent who handled everything while I focused on my new start.",
  position: "Homeowner, Illinois Resident"
}];
export default function OgrenciVeOgretmenGorusleri() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="228730" id="success-stories" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
        <div className="w-full max-w-[800px] aspect-square bg-[radial-gradient(circle_at_center,hsla(44,91%,61%,0.05)_0%,transparent_60%)] rounded-full blur-3xl opacity-70" />
      </div>

      <div className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-default text-foreground mb-4">What Our Clients Say</h2>
            <p className="text-lg font-default text-muted-foreground">Hear from satisfied homeowners who successfully transitioned with LeavingIL™.</p>
          </div>
          
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="p-2 md:p-6">
                    <Card className="bg-card border border-border shadow-xl rounded-md">
                      <CardContent className="flex flex-col items-center text-center p-6 md:p-10">
                        <div className="relative mb-8">
                          <div aria-hidden="true" className="size-20 md:size-24 rounded-full bg-primary text-primary-foreground border-4 border-background shadow-md flex items-center justify-center font-serif font-semibold text-3xl md:text-4xl">
                            {testimonial.author.charAt(0)}
                          </div>
                          <div className="absolute -bottom-3 -right-3 bg-primary text-primary-foreground p-2 rounded-full shadow-lg">
                            <Quote className="size-4 md:size-5" />
                          </div>
                        </div>

                        <Badge variant={testimonial.position.includes("Relocated") ? "secondary" : "default"} className="mb-6 text-sm px-4 py-1 font-default">
                          {testimonial.position}
                        </Badge>

                        <blockquote className="text-2xl md:text-3xl leading-relaxed italic font-default text-foreground mb-8 max-w-3xl">
                          "{testimonial.quote}"
                        </blockquote>

                        <div className="mt-auto">
                          <cite className="not-italic font-semibold text-lg text-foreground font-default">
                            {testimonial.author}
                          </cite>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex items-center justify-center gap-4 mt-8">
              <CarouselPrevious className="relative inset-auto translate-x-0 translate-y-0 bg-white hover:bg-primary text-foreground border-border shadow-sm transition-colors" />
              <CarouselNext className="relative inset-auto translate-x-0 translate-y-0 bg-white hover:bg-primary text-foreground border-border shadow-sm transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}